import clsx from 'clsx'
import React from 'react'

import styles from './CheckboxList.module.css'

const CheckboxList = ({
	className,
	children,
	...props
}: React.DetailedHTMLProps<
	React.HTMLAttributes<HTMLUListElement>,
	HTMLUListElement
>): JSX.Element => {
	return (
		<ul className={clsx(styles.list, className)} {...props}>
			{children}
		</ul>
	)
}

export default CheckboxList
